/**
 * Created by mac on 4/6/24
 */

const LoadingModel = function () {
    cleverapps.EventEmitter.call(this);
};

LoadingModel.prototype = Object.create(cleverapps.EventEmitter.prototype);
LoadingModel.prototype.constructor = LoadingModel;

LoadingModel.prototype.show = function () {
    this.trigger("show");
};

LoadingModel.prototype.hide = function () {
    this.trigger("hide");
};
